import config from '../utils/config'
import request from '../utils/request'

const {api} = config
const {feedbacks,feedback,evtFeedbacks,evtFeedback} = api

/**
 * 查找
 */
export async function findFeedback(params) {
    return request({url: feedback, method: 'get', data: params,})
}
export async function findEvtFeedbacks(params) {
    return request({url: evtFeedbacks, method: 'get', data: params,})
}

export async function createFeedback(params) {
    return request({url: feedbacks, method: 'post', data: params,})
}
/**
 * 回复
 */
export async function replyFeedback(params) {
    return request({url: feedback, method: 'put', data: params,})
}

/**
 * 查找列表
 */
export async function findFeedbacks(params) {
    return request({url: feedbacks, method: 'get', data: params,})
}

/**
 * 删除
 */
export async function deleteFeedback(params) {
    return request({url: feedback, method: 'delete', data: params,})
}
export async function deleteEvtFeedback(params) {
    return request({url: evtFeedback, method: 'delete', data: params,})
}




// WEBPACK FOOTER //
// ./src/services/feedback.js